<script>
import appConfig from "@/app.config.json";
import tableSearch from "@/mixins/tableSearch";
import pagination from "@/mixins/pagination";
import router from "@/mixins/router";
import Layout from "@/views/layouts/main.vue";
import apiEndpoints from "@/services/apiEndpoints";
import datetime from "@/mixins/datetime";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import CommonTableComponent from "@/components/table.vue";
import ManifestInfo from "@/views/pages/daily_reports/manifests/components/manifest_info.vue";
import sweetAlert from "@/mixins/sweetAlert";
import user from "@/mixins/user";
import {mapState} from "vuex";
import scrollToError from "@/mixins/scrollToError";

export default {
  name: "ManifestEdit",
  page: {
    title: "マニフェスト編集",
    meta: [{name: "description", content: appConfig.description}]
  },
  mixins: [tableSearch, pagination, router, datetime, sweetAlert, user, scrollToError],
  components: {
    Layout,
    Multiselect,
    DatePicker,
    CommonTableComponent,
    ManifestInfo
  },
  data() {
    return {
      manifest: {},
      itemsControl: {},
      jwnManifest: {},
      manifestSituation: '',
      finalDisposalSiteByManifest: [],
      jwnTransmissionTask: [],
      isLoading: false,
      modalConfirmDeleteManifest: false,
      manifestId: null,
      numberManifest: null,
      jwnDate: {
        inquiry: '',
        bookRegistration: '',
        transportReport1: '',
        transportReport2: '',
        disposalReport: '',
        finalDisposal: '',
      },
      selectJwnDate:{
        isInquiry: false,
        isBookRegistration: false,
        isTransportReport1: false,
        isTransportReport2: false,
        isDisposalReport: false,
        isFinalDisposal: false,
      },
      manifest1stsByManifest2ndId: '',
      params: null,
      BoxFinal:{
        isJwn:false,
        margin:0,
      },
      ckeditorOptions: this.$ckeditor,
      buttonCancelText: this.$lang.button.cancel,
      buttonDeleteText: this.$lang.button.delete,
      dailyReports: null,
      wastesList:null,
      jwnTransNotice: [],
      errors: [],
    };
  },
  async created() {

    if (this.$router.currentRoute.params.id && this.$router.currentRoute.name == 'manifests.edit' ) {
      this.manifestId = this.$router.currentRoute.params.id;
    } else if (this.$router.currentRoute.params.number && this.$router.currentRoute.name == 'manifests.edit.number') {
      this.numberManifest = this.$router.currentRoute.params.number;
    }

    this.params = this.manifestId ? {id: this.manifestId} : {number_of_issue: this.numberManifest};

    await this.getData();
    await this.getDataJwn();
    // this.getManifestSituation();
    this.getJWNetDate();
    this.getMarginBoxFinal();
    this.getOrSetInfoWasteCategory(false);
    if (this.$router.currentRoute.query.to == "final" && this.$refs.localManifest.$refs.final_disposal_site) {
      this.$refs.localManifest.$refs.final_disposal_site.scrollIntoView({ behavior: 'smooth' });
    }
  },
  methods: {
    async getData() {
      this.isLoading = true;

      const sendApiManifest = await this.$http.get(apiEndpoints.detail_manifest, this.params);

      const {status, data} = sendApiManifest;
      this.isLoading = false;

      if (status && data.result) {
        this.manifest = data.result.manifest;
        this.itemsControl = data.result.items_control;
        this.finalDisposalSiteByManifest = data.result.manifest.final_disposal_site_by_manifest;
        this.jwnTransmissionTask = data.result.manifest.jwn_transmission_task;
        this.manifestSituation = data.result.manifest_status;
        this.wastesList = data.result.wastes_list;
      }
    },
    async getDataJwn() {
      this.isLoading = true;

      const sendApiJwnManifest = await this.$http.get(apiEndpoints.get_jwn_manifest_by_manifest, this.params);

      const {status, data} = sendApiJwnManifest;

      this.isLoading = false;
      if (status && data.result) {
        this.jwnManifest = data.result;
      }

    },
    fixedOptions(values) {
      let options = [];
      for (let i = 0; i < values.length; i++) {
        options.push({value: i + 1, text: values[i]});
      }

      return options;
    },
    handelRedirect() {
      this.$router.push({
        name: 'manifests.attach',
        params: {id: this.manifest.id, date_of_issue: this.manifest.date_of_issue}
      });
    },
    beforeHandelSubmit(isSendRequest) {
      this.confirm(
        '',
        '',
        'マニフェスト情報を登録してもよろしいですか。',
        'info',
        'OK',
        'キャンセル'
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.handelSubmit(isSendRequest);
        }
      });
    },
    async handelSubmit(isSendRequest) {
      const dataJwnTransmissionTask = [
        {key: 'isInquiry', controlNumber: this.$constant.JWNETDateByControlNumber.inquiry},
        {key: 'isBookRegistration', controlNumber: this.$constant.JWNETDateByControlNumber.book_registration},
        {key: 'isTransportReport1', controlNumber: this.$constant.JWNETDateByControlNumber.transport_report},
        {key: 'isTransportReport2', controlNumber: this.$constant.JWNETDateByControlNumber.transport_report},
        {key: 'isDisposalReport', controlNumber: this.$constant.JWNETDateByControlNumber.disposal_report},
        {key: 'isFinalDisposal', controlNumber: this.$constant.JWNETDateByControlNumber.final_disposal}
      ];

      this.manifest.jwn_transmission_task=[];
      let indexTransportReport = [];
      for (const transmissionTask of dataJwnTransmissionTask) {
        let section = null;
        if (this.selectJwnDate[transmissionTask.key]) {
          if (transmissionTask.key == 'isTransportReport1') {
            // this.manifest.sub_transport_vendor_1_end_date = this.formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss');
            section = 1;
          }
          else if (transmissionTask.key == 'isTransportReport2') {
            // this.manifest.sub_transport_vendor_2_end_date = this.formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss');
            section = 2;
          }

          if (!this.manifest.jwn_transmission_task.find(x => x.control_number === transmissionTask.controlNumber)) {
            this.manifest.jwn_transmission_task.push({
              zz_jwn_transmission_task_status_id: this.$constant.zzJwnTransmissionTaskStatuses.reservation,
              control_number: transmissionTask.controlNumber,
              manifest_id: parseInt(this.manifest.id),
              indexTransportReport: indexTransportReport,
              section: section,
            });
          }

          if (transmissionTask.key === 'isDisposalReport') {
            this.manifest['sub_disposal_vendor_reporting_user_name'] = this.currentUser?.user_name;
          }

          if (transmissionTask.key.startsWith('isTransportReport')) {
            const indexTransport = parseInt(transmissionTask.key.replace('isTransportReport', ''));
            if (indexTransport) {
              this.manifest[`sub_transport_vendor_${indexTransport}_reporting_user_name`] = this.currentUser?.user_name;
            }
          }
        }
      }
      await this.editManifest(isSendRequest);
    },
    async editManifest(isSendRequest){
      this.getOrSetInfoWasteCategory(true);
      let params = {...this.manifest,
        jwn_manifest: this.jwnManifest,
        isSendRequest: isSendRequest
      };
      const { status, code, data } = await this.$http.post(apiEndpoints.edit_manifest(this.manifest.id), params);
      if (status) {
        if(data.result.manifest_error){
          return this.$swal.fire({
            icon: "error",
            html: data.result.message,
            width: data.result.width_alert || '70em',
          });
        }
        if(data.result.message_warning_process){
          return this.$swal.fire({
            icon: "warning",
            html: data.result.message_warning_process,
            width: '40em',
          });
        }

        this.successToast("マニフェストを登録しました", false, 2000);
        this.handelBack();
      }else{
      if (this.$helpers.isDisplayFormError(code)) {
        this.errors = data.errors;
        return this.$nextTick(() => {
          this.scrollIntoError();
        });
      } else if (this.$helpers.isDisplayErrorInLocalComponent(code)) {
        if (data.approved_input) {
          return this.alertApprovedWastesOrServices(data.message)
        }
        return this.errorToast(data.message,false , 6000);
      }
      }
    },
    async handelDeleteManifest1st(){

      const { status, data } = await this.$http.post(apiEndpoints.delete_manifests_1sts(this.manifest1stsByManifest2ndId));
      if (status) {
        this.$bvModal.hide('deleteManifest1sts');
        await this.getData();
        return this.successToast("削除に成功しました", false, 2000);
      }
      return this.errorToast(data.message);

    },
    selectManifest1Sts(id){
      this.modalConfirmDeleteManifest = !this.modalConfirmDeleteManifest;
      this.manifest1stsByManifest2ndId = id;
    },
    handelBack() {
      const screen = localStorage['historyManifestEdit'] ? JSON.parse(localStorage['historyManifestEdit']).source : null;
      switch (screen) {
        case "manifests":
          
          this.$router.push({
            name: screen,
            query: localStorage['manifestEdit'] ? JSON.parse(localStorage['manifestEdit']) : {},
          })

          break;

        case "daily.reports.approve":
        case "daily.reports.maintenance.approve":
        case "daily.reports.maintenance.add":

          const dailyReportInputRouter = JSON.parse(localStorage['dailyReportInput']);
          this.$router.push({
            name: screen,
            query: dailyReportInputRouter.query,
            params: { id: dailyReportInputRouter.daily_report_id },
          })

          break;

        default:

          const previousRoute = this.$route.params.previousRoute;
          this.$router.push({
            name: previousRoute.name ? previousRoute.name : 'manifests',
            query: previousRoute && previousRoute.query ? previousRoute.query : {},
            params : previousRoute.params
          })

          break;
      }
    },
    findJwnManifestStatus(zzJwnManifestStatuses, id) {
      return zzJwnManifestStatuses.find(item => item.id === id.toString()).jwn_manifest_status;
    },
    getJWNetDate() {
      const self = this;
      if (this.jwnTransmissionTask) {
        this.jwnTransmissionTask.forEach(function (item) {
          const dateFormats = ['YYYY/MM/DD', 'YYYY/MM/DD HH:mm:ss'];

          switch (item.control_number) {
            case self.$constant.JWNETDateByControlNumber.inquiry:
              self.jwnDate.inquiry = self.getDate(item.last_transferred_at, dateFormats[0]);
              break;

            case self.$constant.JWNETDateByControlNumber.book_registration:
              self.jwnDate.bookRegistration = self.getDate(item.last_transferred_at, dateFormats[0]);
              break;

            case self.$constant.JWNETDateByControlNumber.transport_report:
              if(item.section == 1){
                self.jwnDate.transportReport1 = self.getDate(item.last_transferred_at, dateFormats[0]);
              }else if(item.section == 2){
                self.jwnDate.transportReport2 = self.getDate(item.last_transferred_at, dateFormats[0]);
              }
              break;
            case self.$constant.JWNETDateByControlNumber.disposal_report:
              self.jwnDate.disposalReport = self.getDate(item.last_transferred_at, dateFormats[0]);
              break;

            case self.$constant.JWNETDateByControlNumber.final_disposal:
              self.jwnDate.finalDisposal = self.getDate(item.last_transferred_at, dateFormats[0]);
              break;
          }
        });
      }
    },
    
    isJwnManifestTransport1() {
          return (this.jwnManifest.sub_transport_vendor_1_end_date)
    },
    isJwnManifestTransport2() {
          return (this.jwnManifest.sub_transport_vendor_2_end_date)
    },
    isJwnManifestTransport3() {
          return (this.jwnManifest.sub_transport_vendor_3_end_date)
    },
    isJwnManifestTransport4() {
          return (this.jwnManifest.sub_transport_vendor_4_end_date)
    },
    isJwnManifestTransport5() {
          return (this.jwnManifest.sub_transport_vendor_5_end_date)
    },
    isJwnManifestTreatment() {
          return (this.jwnManifest.sub_disposal_vendor_end_date)
    },
    isJwnManifestFinal(){
      return (this.jwnManifest.final_disposal_site_treatment_end_date)
    },
    getDate(date, format) {
      return this.formatDate(date, format) || '';
    },
    getPersonByWorkOrderType(workOrderType, isTransport) {
      switch (workOrderType) {
        case this.$constant.work_order_type.transportation: // work order type: 02
          if (isTransport) {
            return this.manifest.sub_transport_vendor_1_delivery_person_in_charge;
          }
          break;
        case this.$constant.work_order_type.transportation_disposal: // work order type: 03
          if (isTransport) {
            return this.manifest.sub_transport_vendor_1_delivery_person_in_charge;
          }
          return this.manifest.sub_disposal_vendor_treatment_person_in_charge;
          break;
        case this.$constant.work_order_type.disposal: // work order type: 04
          if (!isTransport) {
            return this.manifest.sub_disposal_vendor_treatment_person_in_charge;
          }
          break;
        case this.$constant.work_order_type.discharge: // work order type: 05
          if (isTransport) {
            return this.manifest.sub_transport_vendor_1_delivery_person_in_charge;
          }
          return this.manifest.sub_disposal_vendor_treatment_person_in_charge;
          break;
        case this.$constant.work_order_type.transshipment_storage: // work order type: 06
          let transportAndHoldSection = this.manifest?.waste_or_service_daily_report?.daily_report?.schedule?.transport_and_hold_section ?? 1;
          if (isTransport) {
            return this.manifest["sub_transport_vendor_" + transportAndHoldSection + "_delivery_person_in_charge"] ?? '';
          }
          break;
        default:
      }
    },
    isDailySpecialCase(WOSbyDailyReport) {
      return WOSbyDailyReport.daily_report.work_order_json.zz_work_order_type_id === this.$constant.work_order_type.transportation_disposal
        && WOSbyDailyReport.vendor_site_id;
    },
    getWorkOrderTypeNameByManifest(manifest) {
      return manifest?.waste_or_service_daily_report?.daily_report?.work_order_json?.work_order_type?.work_order_type ?? '';
    },
    isEdited(key) {
      if (this.itemsControl.hasOwnProperty(key)) {
        return !this.itemsControl[key];
      }
      return true;
    },
    isSent(key){
      switch(key){
        case "jwn_regist":
          return (this.jwnDate.bookRegistration);
        case "jwn_transport_1":
          return (this.jwnDate.transportReport1);
        case "jwn_transport_2":
          return (this.jwnDate.transportReport2);
        case "jwn_transport_3":
          return false;
        case "jwn_transport_4":
          return false;
        case "jwn_transport_5":
          return false;
        case "jwn_treatment":
          return (this.jwnDate.disposalReport);
        case "jwn_final_treatment":
          return (this.jwnDate.finalDisposal);
      }
    },
    getMarginBoxFinal() {
      let countByJwnManifest = this.jwnManifest.final_disposal_site_by_jwn_manifest ? this.jwnManifest.final_disposal_site_by_jwn_manifest.length : 0;
      let countByManifest = this.finalDisposalSiteByManifest.length;
      if (countByJwnManifest > countByManifest) {
        this.BoxFinal.isJwn = false;
        this.BoxFinal.margin = 313 * (countByJwnManifest - countByManifest) + 16;
      } else {
        this.BoxFinal.isJwn = true;
        this.BoxFinal.margin = 313 * (countByManifest - countByJwnManifest)+16;
      }
    },
    getOrSetInfoWasteCategory(isSet) {
      const classifications = [
        'major_classification',
        'medium_classification',
        'minor_classification',
        'subminor_classification'
      ];

      classifications.forEach(classification => {
        const manifestKey = `waste_category_${classification}_cd`;
        if (!isSet) {
          this.manifest[manifestKey] = (this.manifest?.[manifestKey] ?? '') + ((this.manifest?.[manifestKey] || this.manifest.waste_category?.[classification]) ? ':' : '') + (this.manifest.waste_category?.[classification] ?? '');
          this.jwnManifest[manifestKey] = (this.jwnManifest?.[manifestKey] ?? '') + ((this.jwnManifest?.[manifestKey] || this.jwnManifest.waste_category?.[classification]) ? ':' : '') + (this.jwnManifest.waste_category?.[classification] ?? '');
        } else {
          this.manifest[manifestKey] = this.manifest[manifestKey]?.split(':')[0] ?? '';
        }
      });
    },
    is1St(){
      return this.manifest.manifest_stage_cd==this.$constant.zzManifestStages.first;
    },
    isElectronic(){
      return this.manifest.manifest_type_cd==this.$constant.zzManifestTypes.electronic;
    },
    /**
     * 該当日報に運搬日報があるか
     */
    hasTransportReport(item){
      // 承認ステータスが2なら入力不可なので存在しない
      if(item.transport_approved_status == "2") return false;
      return true;
    },
    /**
     * 該当日報に工場日報があるか
     */
    hasTreatmentReport(item){
      if(item.treatment_approved_status == "2") return false;
      return true;
    },
    jwnTransCheck(){
      this.jwnTransNotice = [];
      //this.isPast();
      // いずれかをチェックしてないとJwn送信できないようにする
      let selected = false;
      Object.keys(this.selectJwnDate).forEach(item => {
        selected = selected || this.selectJwnDate[item];
      });
      
      if(!selected){ 
        return true;
      }

      // マニフェスト番号が設定されていない
      if(!this.manifest.number_of_issue){
        this.jwnTransNotice.push("交付番号が設定されていません");
      }

      // 日付は全て未来日じゃない事も確認する

      // チェックした報告対象に対応する日付が設定されていない
      // 本登録
      if(this.selectJwnDate.isBookRegistration){        
        if(!this.manifest.date_of_issue){
          this.jwnTransNotice.push("引渡日が未設定です");
        }else if(this.isFuture(this.manifest.date_of_issue)){
          this.jwnTransNotice.push("引渡日に未来日が設定されています");
        }
        if(!this.manifest.quantity_confirmation_unit_cd){
          this.jwnTransNotice.push("排出量単位が未設定です");
        }
        if(!this.manifest.packing_type_cd){
          this.jwnTransNotice.push("荷姿が未設定です");
        }
        if(this.manifest.quantity_confirmation_company_type_cd == this.$constant.zzJwQuantityConfirmationCompanyTypes.none){
          this.jwnTransNotice.push("数量確定者が未設定です");
        }
      }
      // 運搬1
      if(this.selectJwnDate.isTransportReport1){
        if(!this.manifest.sub_transport_vendor_1_end_date){
          this.jwnTransNotice.push("運搬区間1の運搬終了日が未設定です");
        }else if(this.isFuture(this.manifest.sub_transport_vendor_1_end_date)){
          this.jwnTransNotice.push("運搬区間1の運搬終了日に未来日が設定されています");
        }else if(!this.manifest.sub_transport_vendor_1_delivery_person_in_charge){
          this.jwnTransNotice.push("運搬区間1の運搬担当者が未設定です");
        }
      }
      // 運搬2
      if(this.selectJwnDate.isTransportReport2){
        if(!this.manifest.sub_transport_vendor_2_end_date){
          this.jwnTransNotice.push("運搬区間2の運搬終了日が未設定です");
        }else if(this.isFuture(this.manifest.sub_transport_vendor_2_end_date)){
          this.jwnTransNotice.push("運搬区間2の運搬終了日に未来日が設定されています");
        }else if(!this.manifest.sub_transport_vendor_2_delivery_person_in_charge){
          this.jwnTransNotice.push("運搬区間2の運搬担当者が未設定です");
        }
      }
      // 処分
      if(this.selectJwnDate.isDisposalReport){
        if(!this.manifest.sub_disposal_vendor_end_date){
          this.jwnTransNotice.push("処分終了日が未設定です");
        }else if(this.isFuture(this.manifest.sub_disposal_vendor_end_date)){
          this.jwnTransNotice.push("処分終了日に未来日が設定されています");
        }
      }
      // 最終処分
      // 最終処分だけは最終処分場情報を見ないといけない
      if(this.selectJwnDate.isFinalDisposal){
        // 処理後廃棄物
        this.manifest.wastes_after_treatment_by_manifest.forEach(after => {
          // 最終処分場
          after.final_disposal_site_by_manifest.forEach(item => {
            // 最終処分終了日のチェック
            if(!item.final_disposal_site_treatment_end_date){
              this.jwnTransNotice.push("最終処分終了日が設定されていない最終処分場が存在します");
            }else if(this.isFuture(item.final_disposal_site_treatment_end_date)){
              this.jwnTransNotice.push("最終処分終了日に未来日が設定されている最終処分場が存在します");
            }
          });
        });
      }
    },
    isJwnTransDisabled(){

      // いずれかをチェックしてないとJwn送信できないようにする
      let selected = false;
      Object.keys(this.selectJwnDate).forEach(item => {
        selected = selected || this.selectJwnDate[item];
      });

      if( !selected || this.jwnTransNotice.length > 0) return true;
      return false;
    },
    isDisplayJwnTransNotice(){
      return (this.jwnTransNotice.length > 0);
    },
    openManifest(id1st){  
      this.redirectRouteTargetBlank('manifests.edit', { id: id1st }, {to: "final"}, this.queryPage, 'manifestEdit');
    },
    openWasteInfo(){
      let wasteId = this.manifest.waste_id;
      // wasteListから商流ID取得
      let targetWaste = this.wastesList.filter(waste => 
        waste.id == wasteId
      );
      let caseId = targetWaste[0].case_id;
      this.redirectRouteTargetBlank('projects.sales.wastes.detail', { id: caseId, waste_id:wasteId  }, {}, this.queryPage, 'wasteDetail');
    }
  },
  computed: {
    related_work_daily_report_header() {
      return [
        {
          text: "作業日報NO",
        },
        {
          text: "作業者",
        },
        {
          text: "作業分類",
        },
        {
          text: "日報確認",
        }
      ];
    },
    return_date_header() {
      return [
        {
          text: "B1票",
        },
        {
          text: "B2票",
        },
        {
          text: "C1票",
        },
        {
          text: "C2票",
        },
        {
          text: "D票",
        },
        {
          text: "E票",
        }
      ];
    },
    zzManifestStages() {
      const stageOption = this.$store.getters['options/options_tables'].zz_manifest_stages ?? [];
      return stageOption.map(obj => ({
        text: obj.manifest_stage,
        value: parseInt(obj.id)
      }));
    },
    zzManifestTypes() {
      const typeOption = this.$store.getters['options/options_tables'].zz_manifest_types ?? [];
      return typeOption.map(obj => ({
        text: obj.manifest_type,
        value: parseInt(obj.id)
      }));
    },
    zzJwnManifestStatuses() {
      return this.$store.getters['options/options_tables'].zz_jwn_manifest_statuses ?? [];
    },
    ...mapState({
      currentUser: state => state.auth.user,
    })
  },
  watch: {
    'selectJwnDate':{
      immediate: false, // 画面読み込み時にハンドルするか
      deep:true, // 配列の先まで値を見るか
      handler:function(){ this.jwnTransCheck();}, // 実行する処理
    },
    'manifest':{
      immediate: false, // 画面読み込み時にハンドルするか
      deep:true, // 配列の先まで値を見るか
      handler:function(){ this.jwnTransCheck();}, // 実行する処理
    }
  },
};
</script>
<template>
  <Layout>
    <b-row>
      <b-card>
        <b-row>
          <b-col class="d-flex justify-content-end">
            <button class="btn btn-primary me-2" @click="openWasteInfo()">
              <i class="far fa-clone"></i> 廃棄物情報
            </button>
            <button class="btn btn-primary" @click="handelBack">
              <i class='far fa-arrow-alt-circle-left'></i> {{ this.$lang.button.back }}
            </button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <div class="custom-radio-group gap-2">
              <label class="label-group">一次・二次</label>
              <b-form-radio-group
                class="d-flex align-items-center gap-2 w-100 h-100"
                :options="zzManifestStages"
                v-model="manifest.manifest_stage_cd"
                disabled
              ></b-form-radio-group>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="6">
            <div class="custom-radio-group gap-2">
              <label class="label-group"></label>
                <b-form-checkbox
                  value="1"
                 :disabled="is1St()"
                class="d-flex align-items-center gap-2 w-100 h-100"
                v-model="manifest.manifest_2nd_only">
                一次と紐付け不要</b-form-checkbox>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="6">
            <div class="custom-radio-group gap-2">
              <label class="label-group">媒体</label>
              <b-form-radio-group
                class="d-flex align-items-center gap-2 w-100 h-100"
                :options="zzManifestTypes"
                v-model="manifest.manifest_type_cd"
              ></b-form-radio-group>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="6">
            <div class="custom-radio-group gap-2">
              <label class="label-group">分類</label>
              <b-form-radio-group
                class="d-flex align-items-center gap-2 w-100 h-100"
                :options="fixedOptions(['通常', '積替保管'])"
                v-model="manifest.classification"
                disabled
              ></b-form-radio-group>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="6">
            <div class="custom-input gap-2">
              <label for="">状態</label>
              <b-form-input type="text" v-model="this.manifestSituation" disabled/>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="6">
            <div class="custom-input gap-2">
              <label for="">管理番号</label>
              <b-form-input maxlength="11" type="text" v-model="manifest.control_number" :disabled="isEdited('control_number')"></b-form-input>
            </div>
          </b-col>
        </b-row>
        <div class="d-flex gap-4">
          <ManifestInfo
            :itemsControl="this.itemsControl"
            :isEdit="true"
            :manifest="this.manifest"
            :manifestForDiff="this.jwnManifest"
            :title="'廃棄物追跡システムマニフェスト情報'"
            :class="[manifest.manifest_type_cd == '1'?'w-100':'w-50']"
            :marginBoxFinal="!this.BoxFinal.isJwn ? this.BoxFinal.margin : null"
            :wastesList="this.wastesList"
            :errors="errors"
            ref="localManifest"
          />
          <ManifestInfo
             v-if="isElectronic()"
            :itemsControl="this.itemsControl"
            :manifest="this.jwnManifest"
            :manifestForDiff="this.manifest"
            :title="'JWNETマニフェスト情報'"
            class="w-50"
            :marginBoxFinal="this.BoxFinal.isJwn ? this.BoxFinal.margin : null"
            :errors="errors"
          />
        </div>
        <b-row class="mt-2" v-if="!is1St()">
          <b-col>
            <div class="ps-1 mt-3 bg-info fw-bold font-size-16 text-white title">
              関連一次マニフェスト一覧
            </div>
            <div class="ms-2">
              <b-button variant="primary w-20 mt-2 mr-2" @click="handelRedirect" v-if="canUserEdit()">
                関連する一次マニフェストを追加
              </b-button>
              <div class="gap-3 mt-2">
                <b-badge variant="success"
                         v-if="manifest.manifest1st"
                         v-for="(item, index) in manifest.manifest1st" :key="'manifest1st'+index"
                >
                  <span @click="openManifest(item.manifest_id_1st)">{{ item.manifest.number_of_issue }}</span>
                  <span @click="selectManifest1Sts(item.id)" class="badge badge-icon-custom">×</span>
                </b-badge>
              </div>
            </div>
          </b-col>
          <b-modal
            id="deleteManifest1sts"
            title="関連の削除"
            v-model="modalConfirmDeleteManifest"
          >
            <div class="font-size-14">選択したマニフェストの関連付けを削除します。よろしいですか。</div>
            <template #modal-footer>
              <b-button
                variant="dark"
                size="lg"
                class="float-right"
                @click="modalConfirmDeleteManifest=false"
              >
                <i class="fas fa-times"></i> {{ buttonCancelText }}
              </b-button>
              <b-button
                size="lg"
                class="float-right btn-custom-red"
                v-if="canUserEdit()"
                @click="handelDeleteManifest1st()"
              >
                <i class="fas fa-eraser"></i> {{ buttonDeleteText }}
              </b-button>
            </template>
          </b-modal>
        </b-row>
        <div>
          <div class="ps-1 mt-3 bg-info fw-bold font-size-16 text-white title">
            関連作業日報一覧
          </div>
          <CommonTableComponent :height-class="`table-wrapper-500`">
            <thead class="table-light">
            <tr>
              <th
                v-for="(item, index) in related_work_daily_report_header"
                :key="index"
                :class="[getHeaderClass(item)]"
              >
                <span>
                  {{ item.text }}
                </span>
              </th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="relationalReport in this.manifest.waste_or_service_daily_report">
                <td>{{ relationalReport.daily_report_id }}</td>
                <td>{{ relationalReport.user && relationalReport.user.user_name }}</td>
                <td>{{ relationalReport.daily_report.work_order_json.work_order_type.work_order_type }}</td>
                <td>
                  <button
                    v-if="hasTransportReport(relationalReport)"
                    class="btn btn-primary mr-1"
                    @click="
                      redirectRouteTargetBlank(
                        'daily.reports.approve',
                          {
                            id: relationalReport.daily_report_id
                          },
                          {
                            waste_or_service_ids: relationalReport.id,
                          },
                          {},
                          'manifests'
                      )"
                  >
                    運搬
                  </button>
                  <button
                    v-if="hasTreatmentReport(relationalReport)"
                    class="btn btn-primary mr-1"
                    @click="redirectRouteTargetBlank(
                        'daily.reports.approve',
                          {
                            id: relationalReport.daily_report_id
                          },
                          {
                            waste_or_service_ids: relationalReport.id,
                            vendor_site_id: relationalReport.vendor_site_id
                          },
                          {},
                          'manifests'
                      )"
                  >
                    工場
                  </button>
                </td>
              </tr>
            </tbody>
          </CommonTableComponent>
        </div>
        <div>
          <div class="ps-1 mt-3 bg-info fw-bold font-size-16 text-white title">返却日</div>
          <CommonTableComponent :height-class="`table-wrapper-500`">
            <thead class="table-light">
            <tr>
              <th
                v-for="(item, index) in return_date_header"
                :key="index"
                :class="[getHeaderClass(item)]"
              >
                <span>
                  {{ item.text }}
                </span>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                <div class="input-control">
                <date-picker
                  v-model="manifest.B1_return_date"
                    lang="ja"
                    placeholder="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    value-type="format"
                    type="date"
                  ></date-picker>
                </div>
              </td>
              <td>
                <div class="input-control">
                <date-picker
                  v-model="manifest.B2_return_date"
                    lang="ja"
                    placeholder="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    value-type="format"
                    type="date"
                  ></date-picker>
                </div>
              </td>
              <td>
                <div class="input-control">
                <date-picker
                  v-model="manifest.C1_return_date"
                    lang="ja"
                    placeholder="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    value-type="format"
                    type="date"
                  ></date-picker>
                </div>
              </td>
              <td>
                <div class="input-control">
                <date-picker
                  v-model="manifest.C2_return_date"
                    lang="ja"
                    placeholder="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    value-type="format"
                    type="date"
                  ></date-picker>
                </div>
               </td>
              <td>
                <div class="input-control">
                <date-picker
                  v-model="manifest.D1_return_date"
                    lang="ja"
                    placeholder="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    value-type="format"
                    type="date"
                  ></date-picker>
                </div>
              </td>
              <td>
                <div class="input-control">
                <date-picker
                  v-model="manifest.E1_return_date"
                    lang="ja"
                    placeholder="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    value-type="format"
                    type="date"
                  ></date-picker>
                </div>
              </td>
            </tr>
            </tbody>
          </CommonTableComponent>
        </div>
        <template v-if="isElectronic()">
          <div>
            <div class="ps-1 mt-3 bg-info fw-bold font-size-16 text-white title">
              JWNET連携および最終連携日時
            </div>

            <CommonTableComponent
              class="w-50"
              :height-class="`table-wrapper-500`"
            >
              <thead class="table-light">
                <tr>
                  <th>
                    <span class="d-flex">
                      <b-form-checkbox class="ms-2" v-model="selectJwnDate.isInquiry">照会</b-form-checkbox>
                    </span>
                  </th>
                  <th>
                    <span class="d-flex"><span v-if="!(!isEdited('jwn_regist') && !isSent('jwn_regist'))">本登録</span>
                      <b-form-checkbox v-if="!isEdited('jwn_regist') && !isSent('jwn_regist')" class="ms-2" v-model="selectJwnDate.isBookRegistration">本登録</b-form-checkbox>
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{ this.jwnDate.inquiry }}</td>
                <td>{{ this.jwnDate.bookRegistration }}</td>
              </tr>
              </tbody>
            </CommonTableComponent>
          </div>
          <div>
            <CommonTableComponent :height-class="`table-wrapper-500`">
              <thead class="table-light">
                <tr>
                  <th>
                    <span class="d-flex"> <span v-if="!(!isEdited('jwn_transport_1') && !isSent('jwn_transport_1') && !isJwnManifestTransport1())">運搬報告（区間1）</span>
                      <b-form-checkbox v-if="!isEdited('jwn_transport_1') && !isSent('jwn_transport_1') && !isJwnManifestTransport1()" class="ms-2" v-model="selectJwnDate.isTransportReport1">運搬報告（区間1）</b-form-checkbox>
                    </span>
                  </th>
                  <th>
                    <span class="d-flex"> <span v-if="!(!isEdited('jwn_transport_2') && !isSent('jwn_transport_2') && !isJwnManifestTransport2())">運搬報告（区間2）</span>
                      <b-form-checkbox v-if="!isEdited('jwn_transport_2') && !isSent('jwn_transport_2') && !isJwnManifestTransport2()" class="ms-2" v-model="selectJwnDate.isTransportReport2">運搬報告（区間2）</b-form-checkbox>
                    </span>
                  </th>
                  <th>
                    <span class="d-flex"> <span v-if="!(!isEdited('jwn_transport_3') && !isSent('jwn_transport_3') && !isJwnManifestTransport3())">運搬報告（区間3）</span>
                      <b-form-checkbox v-if="!isEdited('jwn_transport_3') && !isSent('jwn_transport_3') && !isJwnManifestTransport3()" class="ms-2">運搬報告（区間3）</b-form-checkbox>
                    </span>
                  </th>
                  <th>
                    <span class="d-flex"> <span v-if="!(!isEdited('jwn_transport_4') && !isSent('jwn_transport_4') && !isJwnManifestTransport4())" >運搬報告（区間4）</span>
                      <b-form-checkbox v-if="!isEdited('jwn_transport_4') && !isSent('jwn_transport_4') && !isJwnManifestTransport4()" class="ms-2">運搬報告（区間4）</b-form-checkbox>
                    </span>
                  </th>
                  <th>
                    <span class="d-flex"> <span v-if="!(!isEdited('jwn_transport_5') && !isSent('jwn_transport_5') && !isJwnManifestTransport5())">運搬報告（区間5）</span>
                      <b-form-checkbox v-if="!isEdited('jwn_transport_5') && !isSent('jwn_transport_5') && !isJwnManifestTransport5()" class="ms-2">運搬報告（区間5）</b-form-checkbox>
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{ this.jwnDate.transportReport1 }}</td>
                <td>{{ this.jwnDate.transportReport2 }}</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              </tbody>
            </CommonTableComponent>
          </div>
          <div>
            <CommonTableComponent
              class="w-50"
              :height-class="`table-wrapper-500`"
            >
              <thead class="table-light">
              <tr>
                <th>
                  <span class="d-flex">
                  <span v-if="!(!isEdited('jwn_treatment') && !isSent('jwn_treatment') && !isJwnManifestTreatment())">処分報告</span>
                    <b-form-checkbox v-if="!isEdited('jwn_treatment') && !isSent('jwn_treatment') && !isJwnManifestTreatment()" class="ms-2" v-model="selectJwnDate.isDisposalReport">処分報告</b-form-checkbox>
                  </span>
                </th>
                <th>
                  <span class="d-flex">
                    <span v-if="!(!isEdited('jwn_final_treatment') && !isSent('jwn_final_treatment') && !isJwnManifestFinal())">最終処分終了報告</span>
                    <b-form-checkbox v-if="!isEdited('jwn_final_treatment') && !isSent('jwn_final_treatment') && !isJwnManifestFinal()" class="ms-2" v-model="selectJwnDate.isFinalDisposal">最終処分終了報告</b-form-checkbox>
                  </span>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{ this.jwnDate.disposalReport }}</td>
                <td>{{ this.jwnDate.finalDisposal }}</td>
              </tr>
              </tbody>
            </CommonTableComponent>
          </div>
        </template>
        <b-row class="mt-3">
          <div class="custom-textarea gap-2">
            <label for="textarea">コメント</label>
              <b-form-textarea
                rows="4"
                max-rows="6"
                v-model="manifest.comments"
              ></b-form-textarea>
          </div>
        </b-row>
        <b-row class="mt-3" v-if="isDisplayJwnTransNotice()" >
          <div class="alert alert-danger">
              <i class="mdi mdi-block-helper me-2"></i>
              以下の理由のため、選択したJWN連携は行えません。
              <ul>
                <li v-for="(msg, idx) in this.jwnTransNotice">{{ msg }}</li>
              </ul>
          </div>
        </b-row>
        <b-row class="mt-3">
          <div class="text-center">
            <button
              class="btn btn-primary mr-1"
              @click="beforeHandelSubmit(true)"
              v-if="isElectronic() && canUserEdit()"
              :disabled="isJwnTransDisabled()"
            >
            <i class='fas fa-pencil-alt'></i>
              保存してJWネット連携
            </button>
            <button class="btn btn-primary mr-1" @click="beforeHandelSubmit(false)" v-if="canUserEdit()" :disabled="!isJwnTransDisabled()">
              <i class='fas fa-pencil-alt'></i>
              登録
            </button>
            <button class="btn btn-primary" @click="handelBack">
              <i class='far fa-arrow-alt-circle-left'></i> {{ this.$lang.button.back }}
            </button>
          </div>
        </b-row>
      </b-card>
    </b-row>
    <div class="page-navi">
      <a href="#:~:text=一次・二次">・ページトップ</a>
      <a href="#:~:text=排出事業者情報">・排出情報</a>
      <a href="#:~:text=運搬予定情報">・運搬予定情報</a>
      <a href="#:~:text=処分予定情報">・処分予定情報</a>
      <a href="#:~:text=備考情報">・備考</a>
      <a href="#:~:text=運搬の受託">・運搬実績情報</a>
      <a href="#:~:text=処分の受託">・処分実績情報</a>
      <a href="#:~:text=コメント">・ページボトム</a>
    </div>
  </Layout>
</template>
<style lang="scss" scoped>
.custom-radio-group {
  .label-group {
    flex: 1 0 100px;
  }
}

.badge.badge-icon-custom {
  color: white;
  padding: 2px 6px;
  border-radius: 50%;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
}

.badge.badge-success {
  font-size: 14px;
  background: #28a745;
  color: white;
}

.page-navi a{
  color: white;
}
.page-navi{
  padding: 5px;
  position: fixed;
  width: 200px;
  border-radius: 8px;
  background-color: blue;
  right:20px;
  bottom:20px;
  z-index:99;
  // text-shadow: 2px 2px 3px black;
  opacity: 0.7;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
</style>
